import { getWeixinTicket } from '@/api/open'
import { sha1 } from '@/plugins/getSha1'

export async function getWeixinTicketAsync(urlString) {
    let { status, data } = await getWeixinTicket()
    if (status) {
        let wx = window.wx
        let noncestr = randomString(16)
        let jsapi_ticket = data
        let timestamp = parseInt(new Date().getTime() / 1000)
            // let url = window.location.href.split('#')[0]
        let url = urlString
        let string = 'jsapi_ticket=' + jsapi_ticket + '&noncestr=' + noncestr + '&timestamp=' + timestamp + '&url=' + url
        let signature = sha1(string.toString())
        wx.config({
            beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: 'wx5e2fd8da52d6ac26', // 必填，企业微信的corpID
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
            jsApiList: ['chooseImage', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'showOptionMenu', 'getLocalImgData'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        });
        wx.error(function(res) {
            localStorage.setItem('noAppId', true)
        });
    } else {
        localStorage.setItem('noAppId', true)
    }
}

function randomString(e) {
    e = e || 16;
    var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
        a = t.length,
        n = "";
    for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
    return n
}

// export default getWeixinTicketAsync